// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"13692031","532":"275cece5","722":"275cece5"}[chunkId] + ".chunk.css";
};